import { Button, Input, Modal } from 'antd';
import axios from 'axios';
import { memo, useCallback, useContext, useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { apiUrl } from '../../utils/constants';
import AlertMessage from './AlertMessage';

const TwoFactorForm = ({ openModalTwoFactor, handleCancelModalTwoFactor }) => {
  const { logoutUser } = useContext(AuthContext);
  const [twoFactorCode, setTwoFactorCode] = useState('');
  const [alert, setAlert] = useState(null);

  const closeModal = useCallback(() => {
    setTwoFactorCode('');
    setAlert(null);
    handleCancelModalTwoFactor();
  }, [handleCancelModalTwoFactor]);

  const submitTurnOn2FA = useCallback(
    async (e) => {
      e.preventDefault();
      if (twoFactorCode) {
        try {
          await axios.put(`${apiUrl}/2fa/turn-on`, {
            twoFactorCode,
          });
          closeModal();
          logoutUser();
        } catch (error) {
          setAlert({
            type: 'error',
            message: error?.response?.data?.message || 'Authenticate failed',
          });
          setTimeout(() => setAlert(null), 3000);
        }
      }
    },
    [closeModal, logoutUser, twoFactorCode]
  );

  return (
    <Modal
      open={openModalTwoFactor}
      title="Step 2/2: Submit 2FA code"
      afterClose={closeModal}
      onCancel={closeModal}
      footer={[]}
    >
      <Input
        placeholder="Enter the code here"
        style={{ marginTop: '5px' }}
        name={twoFactorCode}
        value={twoFactorCode}
        onChange={(event) => {
          setTwoFactorCode(event.target.value);
        }}
      />
      <Button
        type="primary"
        block
        style={{ marginTop: '10px' }}
        onClick={submitTurnOn2FA}
        disabled={!twoFactorCode}
      >
        Submit
      </Button>
      <AlertMessage info={alert} />
    </Modal>
  );
};

export default memo(TwoFactorForm);
